<template lang="pug">
.buddy.col-12.col-md-6
  h4
  .sprite-wrapper
    sprite-render.sprite(:sprite='favoriteMonster', :class='{nonToken: !favoriteMonster.tokenId}')
    img.island(src='../../assets/island-1@3x.png')
  sprite-name-display(:sprite='favoriteMonster')
  div
    .level Level {{ favoriteMonster.level || 0 }}
    .progress-wrap
      .progress-item
        .exp-fill(:style="{width: `${expPercent}%`}")
    .exp {{ favoriteMonster.experience - expToPrevLevel }} / {{ expToNextLevel - expToPrevLevel }} EXP
    //.energy-wrap.text-center
      div
        img(v-for='n in 6', src='../../assets/energy.svg', :class="{active: n === 1}")
      div
        strong Energy
</template>

<style>
  .sprite-wrapper .sprite img {
    min-height: 150px;
  }
</style>

<style lang="scss" scoped>
  .buddy, .user-monsters {
    min-height: 300px;
    text-align: left;
  }

  .buddy .level {
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: 1px;
    color: #6c6d69;
    width: 60px;
    margin: 0 auto;
    margin-bottom: .3em;
  }

  .buddy .circle {
    width: 150px;
    height: 150px;
  }

  .sprite-wrapper {
    min-height: 400px;
    position: relative;
  }

  .sprite, .island {
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }

  .sprite {
    transform-origin: 50% 50%;
    animation: bounce .35s ease alternate infinite;
    top: 40px;
    max-height: 200px;
  }

  .nonToken {
    animation: MoveUpDown 2s ease infinite;
    top: -20px;
  }

  @keyframes bounce {
    0% {
      transform: translate3d(0, 0, 0) scale3d(1, 1, 1);
    }
    50% {
      transform: translate3d(0,-2px,0) scale3d(.98, 1.02, 1);
    }
    100% {
      transform: translate3d(0,8px,0) scale3d(1.02,.92,1);
    }
  }

  @keyframes MoveUpDown {
    0%, 100% {
      top: -10px;
    }
    50% {
      top: 10px;
    }
  }

  .island {
    width: 320px;
    z-index: -1;
    top: 120px;
  }

  .progress-wrap {
    position: relative;
  }

  .progress-item {
    width: 100%;
    max-width: 375px;
    height: 8px;
    border-radius: 999px;
    background-color: #d7dad2;
    margin: 0 auto;
  }

  .exp-fill {
    width: 84px;
    max-width: 100%;
    height: 8px;
    border-radius: 999px;
    background-color: #33d238;
  }

  .exp {
    margin: 0 auto;
    width: 150px;
    // font-family: ProximaSoft;
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: 0.5px;
    text-align: center;
    color: #6c6d69;
    margin-top: .5em;
    margin-bottom: .5em;
  }

  .energy-wrap {
    margin-top: .5em;
    margin-bottom: 1em;

    img {
      width: 15.5px;
      margin-right: .3rem;
    }

    strong {
      text-transform: uppercase;
      font-size: 12px;
      color: #6c6d69;
    }
  }
</style>

<script>
import axios from 'axios';
import SpriteRender from './SpriteRender';
import SpriteNameDisplay from './SpriteNameDisplay';

export default {
  components: {
    SpriteRender,
    SpriteNameDisplay,
  },
  data() {
    return {
      editingName: false,
      newName: this.$store.state.favoriteMonster.name,
    };
  },
  computed: {
    favoriteMonster() {
      return this.$store.state.favoriteMonster;
    },
    expToNextLevel() {
      return this.getExpForLevel(this.favoriteMonster.level + 1);
    },
    expToPrevLevel() {
      if (!this.favoriteMonster.level || this.favoriteMonster.level === 0) return 0;
      return this.getExpForLevel(this.favoriteMonster.level);
    },
    expPercent() {
      const current = this.favoriteMonster.experience - this.expToPrevLevel;
      const total = this.expToNextLevel - this.expToPrevLevel;
      return (current / total) * 100;
    },
  },
  methods: {
    // @TODO: Move to library
    getExpForLevel(nextLevel) {
      if (nextLevel === 1) return 110;

      const numberOfNewActions = nextLevel + 10;
      const numberOfBaseActions = 1 + 10;
      const numerator = (numberOfNewActions - numberOfBaseActions + 1) * (numberOfNewActions + numberOfBaseActions);
      const arithsum = numerator / 2;
      const experienceRequiredToLevel = arithsum * 10;

      return experienceRequiredToLevel;
    },
    toggleNameEdit() {
      this.editingName = !this.editingName;

      if (this.editingName || this.newName === this.favoriteMonster.name) return;

      if (this.newName.length > 25) {
        alert('The name must be under 25 characters.');
        return;
      }

      // @TODO: Move to action
      axios.post(`/sprites/${this.favoriteMonster._id}/rename`, { name: this.newName });

      // @TODO: Move to mutation
      this.$store.state.favoriteMonster.name = this.newName;

      const spriteToUpdate = this.$store.state.usersMonsters.find(sprite => sprite._id === this.favoriteMonster._id);
      spriteToUpdate.name = this.newName;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/monsters/MainSprite.vue